"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = exports.SidebarComponent = exports.useSidebarContext = exports.SidebarContextProvider = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const NavItem_1 = require("../../../nav/NavItem");
const NavItemsContextProvider_1 = require("../../../nav/NavItemsContextProvider");
_a = NavItemsContextProvider_1.createNavItemsContextProvider(), exports.SidebarContextProvider = _a.NavItemsContextProvider, exports.useSidebarContext = _a.useNavItemsContext;
function SidebarComponent({ children }) {
    const { navItems } = exports.useSidebarContext();
    return (jsx_runtime_1.jsxs("div", { children: [jsx_runtime_1.jsx("div", { children: jsx_runtime_1.jsx("ul", { children: jsx_runtime_1.jsx(NavItem_1.NavItems, { navItems: navItems }, void 0) }, void 0) }, void 0),
            jsx_runtime_1.jsx("div", { children: children }, void 0)] }, void 0));
}
exports.SidebarComponent = SidebarComponent;
function Sidebar(_a) {
    var { children, Component, sidebar } = _a, props = tslib_1.__rest(_a, ["children", "Component", "sidebar"]);
    if (!Component) {
        Component = SidebarComponent;
    }
    return (jsx_runtime_1.jsx(exports.SidebarContextProvider, Object.assign({}, props, { children: jsx_runtime_1.jsx(Component, Object.assign({}, sidebar, { children: children }), void 0) }), void 0));
}
exports.Sidebar = Sidebar;
//# sourceMappingURL=Sidebar.js.map